import { useRef } from "react";

import Table from "ds/components/Table";
import TableBody from "ds/components/Table/Body";
import TableSkeleton from "ds/components/Table/Skeleton";
import TableWrapper from "ds/components/Table/Wrapper";
import TableSimpleHead from "ds/components/TableSimple/Head";
import TableSimpleLoadMoreRow from "ds/components/TableSimple/LoadMoreRow";
import { LOAD_MORE_ROOT_MARGIN } from "ds/components/TableSimple/constants";
import { PolicyTemplate } from "types/generated";

import { FILTERS_ORDER_SETTINGS_KEY } from "../constants";
import { POLICY_TEMPLATES_SORT_CONFIG } from "./constants";
import PoliciesTemplatesTableRows from "./Rows";
import usePolicyTemplatesTableStore from "./useStore";

type PoliciesTemplatesTableProps = {
  data: PolicyTemplate[];
  loading: boolean;
  canManagePolicies: boolean;
  takenPolicyNames: string[];
  onLoadMore?: () => void;
};

const PoliciesTemplatesTable = ({
  data,
  loading,
  canManagePolicies,
  takenPolicyNames,
  onLoadMore,
}: PoliciesTemplatesTableProps) => {
  const tableRef = useRef<HTMLDivElement>(null);
  const columnIds = usePolicyTemplatesTableStore((state) => state.columnsOrder.visible);

  const isInitialLoading = loading && !data.length;

  return (
    <TableWrapper ref={tableRef} hasPagination={false}>
      <Table ariaLabel="Policy templates">
        <TableSimpleHead
          store={usePolicyTemplatesTableStore}
          ariaLabel="Policy templates"
          tableRef={tableRef}
          filtersStorageKey={FILTERS_ORDER_SETTINGS_KEY}
          sortConfig={POLICY_TEMPLATES_SORT_CONFIG}
        />
        {isInitialLoading && <TableSkeleton columnIds={columnIds} rowsPerPage={20} />}
        <TableBody>
          {!isInitialLoading && (
            <>
              <PoliciesTemplatesTableRows
                data={data}
                store={usePolicyTemplatesTableStore}
                tableRef={tableRef}
                canManagePolicies={canManagePolicies}
                takenPolicyNames={takenPolicyNames}
              />
              {onLoadMore && (
                <TableSimpleLoadMoreRow
                  onLoadMore={onLoadMore}
                  columnsCount={columnIds.length}
                  rootMargin={LOAD_MORE_ROOT_MARGIN}
                  scrollContainerRef={tableRef}
                />
              )}
            </>
          )}
        </TableBody>
      </Table>
    </TableWrapper>
  );
};

export default PoliciesTemplatesTable;
